import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ShopTitleResolver implements Resolve<string> {
  resolve(): string {
    const brand = window.location.href?.toLowerCase();
    if (brand?.includes('seepex')) {
      return 'SERVICEPOINT.VISIT_E_SHOP.SEEPEX.TITLE';
    } else if (brand?.includes('robuschi')) {
      return 'SERVICEPOINT.VISIT_E_SHOP.ROBUSCHI.TITLE';
    } else if (brand?.includes('elmo') || brand?.includes('rietschle')) {
      return 'SERVICEPOINT.VISIT_E_SHOP.ELMO.TITLE';
    }
    return 'SERVICEPOINT.VISIT_E_SHOP.SEEPEX.TITLE';
  }
}
